import axios from '../../../utils/axios';
import { createSlice } from '@reduxjs/toolkit';
import { uniqueId } from 'lodash';
import { sub } from 'date-fns';

const API_URL = '/api/data/chat/ChatData';

const initialState = {
  chats: [],
  chatContent: 1,
  chatSearch: '',
  messageCount: 0
};

export const ChatSlice = createSlice({
  name: 'chat',
  //analogous to model
  initialState,
  //analogous to controller logic
  reducers: {
    getChats: (state, action) => {
      state.chats = action.payload;
    },
    SearchChat: (state, action) => {
      state.chatSearch = action.payload;
    },
    SelectChat: (state, action) => {
      state.chatContent = action.payload;
    },
    SetMessageCount: (state, action) => {
      state.messageCount = action.payload;
    },
    sendMsg: (state, action) => {
      const conversation = action.payload;
      const { id, msg } = conversation;

      const newMessage = {
        id: id,
        msg: msg,
        type: 'text',
        attachments: [],
        createdAt: sub(new Date(), { seconds: 1 }),
        senderId: uniqueId(),
      };

      state.chats = state.chats.map((chat) =>
        chat.id === action.payload.id
          ? {
              ...chat,
              ...chat.messages.push(newMessage),
            }
          : chat,
      );
      state.messageCount+=1
    },
  },
});

export const { SearchChat, getChats, sendMsg, SelectChat, SetMessageCount } = ChatSlice.actions;

//analogous to middleware
export const fetchChats = () => async (dispatch) => {
  try {
    const response = await axios.get(`${API_URL}`);
    dispatch(getChats(response.data));
  } catch (err) {
    throw new Error(err);
  }
};

export const getMsgNum = (storeid, clientid, startdate, enddate) => async (dispatch) => {
  try {
    const response = await axios.get(`${API_URL}`);
    const chats = response.data;
    const filteredmessages = chats.flatMap(chat => chat.messages)
      .filter(message => {
        const messageDate = new Date(message.createdAt);
        return message.senderId === storeid &&
               (!startdate || messageDate >= new Date(startdate)) &&
               (!enddate || messageDate <= new Date(enddate))
      });
    dispatch(filteredmessages.length);
  } catch (err) {
    throw new Error(err);
  }
};

export default ChatSlice.reducer;
